/* @ngInject */
function BrandSectionController ($scope, $q, $sce, ModalService, UdsModalService, ToastService, BrandService, BrandColorPaletteService) {
  const getFontConfigurationDialogController = () => $q.when(import('../../dialogs/font-configuration/font-configuration-dialog.controller'))
  const getBrandSectionFormDialogController = () => $q.when(import('./../../dialogs/brand-section-form/brand-section-form-dialog.controller'))
  const getBrandSectionCategoryFormDialogController = () => $q.when(import('./../../dialogs/brand-section-category-form/brand-section-category-form-dialog.controller'))
  const getDeleteBrandSectionDialogController = () => $q.when(import('../../../admin/dialogs/delete-brand-section/delete-brand-section-dialog.controller'))

  // $scope.section
  $scope.categories = []
  $scope.sectionDescription = ''
  $scope.flags = {
    loading: true
  }

  const api = {
    getFontConfigurationDialogController,
    getBrandSectionFormDialogController,
    getBrandSectionCategoryFormDialogController,
    getDeleteBrandSectionDialogController,
    _handleSuccessGetBrandSectionCategories,
    _handleErrorGetBrandSectionCategories,
    _handleSuccessUpdateSectionOrder,
    _handleErrorUpdateSectionOrder,
    _handleSuccessDeleteSection,
    _handleErrorDeleteSection,
    _handleDefaultFinally
  }
  this.getApi = () => api

  activate()

  function activate () {
    $scope.sectionDescription = $sce.trustAsHtml($scope.section.description)

    if ($scope.section.type === 'COLOR') {
      BrandColorPaletteService.getBrandColorPalettes()
        .then(api._handleSuccessGetBrandSectionCategories)
        .catch(api._handleErrorGetBrandSectionCategories)
        .finally(api._handleDefaultFinally)
    } else {
      BrandService.getBrandSectionCategories($scope.section.id)
        .then(api._handleSuccessGetBrandSectionCategories)
        .catch(api._handleErrorGetBrandSectionCategories)
        .finally(api._handleDefaultFinally)
    }
  }

  $scope.handleEditSection = function (section) {
    api.getBrandSectionFormDialogController().then(({ BrandSectionFormDialogController }) => {
      const dialog = UdsModalService.createModal({
        controller: BrandSectionFormDialogController,
        modalName: 'brandSectionFormDialog',
        data: {
          section: section
        },
        onClose: (updatedSection) => {
          if (updatedSection) {
            $scope.section.title = updatedSection.title
            $scope.section.description = updatedSection.description
            $scope.sectionDescription = $sce.trustAsHtml($scope.section.description)
            $scope.section.allowUserDownload = updatedSection.allowUserDownload
            $scope.section.allowAiUsage = updatedSection.allowAiUsage
            $scope.section.updatedAt = new Date().toISOString()
          }
        }
      })

      dialog.open()
    })
  }

  $scope.handleDeleteSection = function (section) {
    api.getDeleteBrandSectionDialogController().then(({ DeleteBrandSectionDialogController }) => {
      ModalService.showModal({
        templateId: 'deleteBrandSection.html',
        templateUrl: '/admin/dialogs/delete-brand-section/delete-brand-section-dialog.html?$$REVISION$$',
        destroyable: true,
        observeChanges: true,
        allowMultiple: true,
        controller: DeleteBrandSectionDialogController,
        data: {
          data: {
            section
          },
          type: 'section'
        }
      }).then((deleted) => {
        if (deleted) {
          ModalService.close(true)
          $scope.$emit('reloadBrandSections')
        }
      })
    })
  }

  $scope.handleDefaultFontConfiguration = function () {
    api.getFontConfigurationDialogController().then(({ FontConfigurationDialogController }) => {
      ModalService.showModal({
        templateId: 'fontConfiguration.html',
        templateUrl: '/brand/dialogs/font-configuration/font-configuration-dialog.html?$$REVISION$$',
        destroyable: true,
        controller: FontConfigurationDialogController
      })
    })
  }

  $scope.handleMoveSection = function (oldOrder, newOrder) {
    $scope.flags.loading = true
    BrandService.updateBrandSectionOrder(oldOrder, newOrder).then(api._handleSuccessUpdateSectionOrder).catch(api._handleErrorUpdateSectionOrder)
  }

  $scope.handleNewCategory = function (section) {
    api.getBrandSectionCategoryFormDialogController().then(({ BrandSectionCategoryFormDialogController }) => {
      const dialog = UdsModalService.createModal({
        controller: BrandSectionCategoryFormDialogController,
        modalName: 'brandSectionCategoryFormDialog',
        data: {
          section: section
        },
        onClose: (category) => {
          if (category) {
            $scope.categories.push(category)
          }
        }
      })

      dialog.open()
    })
  }

  function _handleSuccessGetBrandSectionCategories (categories) {
    $scope.categories = categories
    $scope.flags.loading = false
  }

  function _handleErrorGetBrandSectionCategories () {
    $scope.flags.loading = false
  }

  function _handleSuccessUpdateSectionOrder () {
    $scope.flags.loading = false
    $scope.$emit('reloadBrandSections')
  }

  function _handleErrorUpdateSectionOrder () {
    $scope.flags.loading = false
    ToastService.defaultErrorToast()
  }

  function _handleSuccessDeleteSection () {
    $scope.flags.loading = false
    $scope.$emit('reloadBrandSections')
  }

  function _handleErrorDeleteSection () {
    $scope.flags.loading = false
    ToastService.defaultErrorToast()
  }

  function _handleDefaultFinally () {
    $scope.$emit('brand-sections-loaded')
  }
}

export { BrandSectionController }
